import script from "./LightSubDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./LightSubDetail.vue?vue&type=script&setup=true&lang=js"

import "./LightSubDetail.vue?vue&type=style&index=0&id=2bc07f77&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc07f77"]])

export default __exports__